import {client} from '../helpers/api';

export async function getCheckTrialStatus({kidId}) {
  if (!kidId) {
    throw new Error('kidId is required');
  }
  const response = await client.get(`/api/check-trial-status/${kidId}`);

  if (response.data?.status !== undefined) {
    const canRequest = response.data?.status;
    const expireDate = response.data?.trial_end_date;

    return {
      showUI: canRequest || expireDate,
      canRequest,
      message: response.data?.message,
      expireDate,
    };
  }
  throw response;
}

// hide trial Box
// status: false,
// message: "You can't apply for trial!",
// errorCode: 101

// display trial Box with expiry date
// status: false,
// message: "Already Applied for trial!",
// errorCode: 100
// trial_end_date: "2021-02-29"

// display trial box with button
// status: true,
// message: "You can apply for trial!",
